import { render } from "./completeOfferForm.vue?vue&type=template&id=bf4654bc&ts=true"
import script from "./completeOfferForm.vue?vue&type=script&lang=ts"
export * from "./completeOfferForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__